import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const BrandsLogos = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const logos = [
    {
      src: "https://assets.zyrosite.com/AoPq4BlPOzuDaPlb/1-m5KL8Vyn5RFrLEj1.svg",
      alt: "Logo 1",
    },
    {
      src: "https://www.assavio.com/static/media/Approvelogo1.8bab2de750199a983526.png",
      alt: "Logo 2",
    },
    {
      src: "https://res.cloudinary.com/dqxlte6wf/image/upload/v1763989487/Screenshot_2025-11-24_at_6.28.13_PM_uno2xt.png",
      alt: "Logo 3",
    },
    {
      src: "https://res.cloudinary.com/dqxlte6wf/image/upload/v1763990061/Screenshot_2025-11-24_at_6.43.49_PM_dgolhh.png",
      alt: "Logo 4",
    },
  ];

  // Container animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.15,
      },
    },
  };

  // Logo item animation variants
  const itemVariants = {
    hidden: {
      y: 30,
      opacity: 0,
      scale: 0.8,
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  // Hover animation for logos
  const logoHoverVariants = {
    rest: {
      scale: 1,
      y: 0,
      rotate: 0,
      filter: "grayscale(70%) brightness(80%)",
      transition: { duration: 0.3, ease: "easeOut" },
    },
    hover: {
      scale: 1.15,
      y: -5,
      rotate: [0, -2, 0, 2, 0],
      filter: "grayscale(0%) brightness(100%)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  // Glow effect animation
  const glowVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 1.5, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      className="w-full bg-gray-100 py-16 px-4 sm:px-6 lg:px-12 relative overflow-hidden"
    >
      {/* Animated background circles */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-blue-900/10 blur-3xl"
        animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />

      <motion.div
        className="absolute bottom-1/3 right-1/4 w-48 h-48 rounded-full bg-purple-800/10 blur-3xl"
        animate={{ scale: [1.2, 1, 1.2], opacity: [0.4, 0.2, 0.4] }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1,
        }}
      />

      {/* LOGOS GRID */}
      <motion.div
        variants={containerVariants}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 items-center justify-center relative z-10"
      >
        {logos.map((logo, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="flex justify-center items-center p-2"
            whileHover="hover"
            initial="rest"
            animate="rest"
          >
            <motion.div
              variants={logoHoverVariants}
              className="relative p-4 rounded-xl"
            >
              {/* Glow effect behind */}
              <motion.div
                className="absolute inset-0 bg-primaryBtnHoverColor/20 rounded-xl opacity-0 z-0"
                variants={glowVariants}
                whileHover={{
                  opacity: 1,
                  transition: { duration: 0.3 },
                }}
              />

              <img
                src={logo.src}
                alt={logo.alt}
                className="h-12 md:h-16 w-auto object-contain relative z-10"
              />
            </motion.div>
          </motion.div>
        ))}
      </motion.div>

      {/* Floating particles */}
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 rounded-full bg-primaryBtnHoverColor/30"
          style={{
            left: `${10 + i * 15}%`,
            top: `${20 + i * 10}%`,
          }}
          animate={{ y: [0, -15, 0], opacity: [0.3, 0.7, 0.3] }}
          transition={{
            duration: 3 + i,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.5,
          }}
        />
      ))}
    </motion.section>
  );
};

export default BrandsLogos;







// import React, { useRef } from "react";
// import { motion, useInView } from "framer-motion";

// const BrandsLogos = () => {
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.2 });

//   const logos = [
//     {
//       src: "https://assets.zyrosite.com/AoPq4BlPOzuDaPlb/1-m5KL8Vyn5RFrLEj1.svg",
//       alt: "Logo 1",
//     },
//     {
//       src: "https://www.assavio.com/static/media/Approvelogo1.8bab2de750199a983526.png",
//       alt: "Logo 2",
//     },
//     {
//       src: "https://res.cloudinary.com/dqxlte6wf/image/upload/v1763989487/Screenshot_2025-11-24_at_6.28.13_PM_uno2xt.png",
//       alt: "Logo 3",
//     },
//     {
//       src: "https://www.webbocket.com/assets/fullwbLogoWhite-BvAf-9qa.svg",
//       alt: "Logo 4",
//     },
//     // { src: logo5, alt: "Logo 5" },
//     // { src: logo6, alt: "Logo 6" },
//   ];

//   // Container animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         delayChildren: 0.3,
//         staggerChildren: 0.15,
//       },
//     },
//   };

//   // Logo item animation variants
//   const itemVariants = {
//     hidden: {
//       y: 30,
//       opacity: 0,
//       scale: 0.8,
//     },
//     visible: {
//       y: 0,
//       opacity: 1,
//       scale: 1,
//       transition: {
//         duration: 0.6,
//         ease: "easeOut",
//       },
//     },
//   };

//   // Hover animation for logos
//   const logoHoverVariants = {
//     rest: {
//       scale: 1,
//       y: 0,
//       rotate: 0,
//       filter: "grayscale(70%) brightness(80%)",
//       transition: {
//         duration: 0.3,
//         ease: "easeOut",
//       },
//     },
//     hover: {
//       scale: 1.15,
//       y: -5,
//       rotate: [0, -2, 0, 2, 0],
//       filter: "grayscale(0%) brightness(100%)",
//       transition: {
//         duration: 0.4,
//         ease: "easeOut",
//       },
//     },
//   };

//   // Text animation variants
//   const textVariants = {
//     hidden: {
//       opacity: 0,
//       y: 20,
//     },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.6,
//         delay: 0.8,
//         ease: "easeOut",
//       },
//     },
//   };

//   // Glow effect animation
//   const glowVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         duration: 1.5,
//         ease: "easeOut",
//       },
//     },
//   };

//   return (
//     <motion.section
//       ref={ref}
//       initial="hidden"
//       animate={isInView ? "visible" : "hidden"}
//       className="w-full bg-[#000002] py-16 px-4 sm:px-6 lg:px-12 relative overflow-hidden"
//     >
//       {/* Animated background elements */}
//       <motion.div
//         className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-blue-900/10 blur-3xl"
//         animate={{
//           scale: [1, 1.2, 1],
//           opacity: [0.3, 0.5, 0.3],
//         }}
//         transition={{
//           duration: 8,
//           repeat: Infinity,
//           ease: "easeInOut",
//         }}
//       />

//       <motion.div
//         className="absolute bottom-1/3 right-1/4 w-48 h-48 rounded-full bg-purple-800/10 blur-3xl"
//         animate={{
//           scale: [1.2, 1, 1.2],
//           opacity: [0.4, 0.2, 0.4],
//         }}
//         transition={{
//           duration: 7,
//           repeat: Infinity,
//           ease: "easeInOut",
//           delay: 1,
//         }}
//       />

//       <motion.div
//         variants={containerVariants}
//         className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 items-center relative z-10"
//       >
//         {logos.map((logo, index) => (
//           <motion.div
//             key={index}
//             variants={itemVariants}
//             className="flex justify-center items-center p-2"
//             whileHover="hover"
//             initial="rest"
//             animate="rest"
//           >
//             <motion.div
//               variants={logoHoverVariants}
//               className="relative p-3 rounded-xl"
//             >
//               {/* Glow effect on hover */}
//               <motion.div
//                 className="absolute inset-0 bg-primaryBtnHoverColor/20 rounded-xl opacity-0"
//                 variants={glowVariants}
//                 whileHover={{
//                   opacity: 1,
//                   transition: { duration: 0.3 },
//                 }}
//               />

//               <img
//                 src={logo.src}
//                 alt={logo.alt}
//                 className="h-12 md:h-16 w-auto object-contain relative z-10"
//               />
//             </motion.div>
//           </motion.div>
//         ))}
//       </motion.div>

//       {/* Floating particles */}
//       {[...Array(6)].map((_, i) => (
//         <motion.div
//           key={i}
//           className="absolute w-2 h-2 rounded-full bg-primaryBtnHoverColor/30"
//           style={{
//             left: `${10 + i * 15}%`,
//             top: `${20 + i * 10}%`,
//           }}
//           animate={{
//             y: [0, -15, 0],
//             opacity: [0.3, 0.7, 0.3],
//           }}
//           transition={{
//             duration: 3 + i,
//             repeat: Infinity,
//             ease: "easeInOut",
//             delay: i * 0.5,
//           }}
//         />
//       ))}
//     </motion.section>
//   );
// };

// export default BrandsLogos;
